function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M501 109c7 6 11 14 11 23 0 8-3 15-8 20l-2 2-114 103c-12 11-30 10-41-2s-10-30 2-41l59-53H199c-16 0-28-13-28-29s13-29 28-29h209l-59-53c-12-10-13-29-2-40 11-12 29-13 41-3zM11 383c-7-6-11-14-11-23 0-8 3-15 8-20 0-1 1-1 1-2l115-103c12-11 30-10 41 2 10 12 9 30-2 41l-60 53h209c16 0 29 13 29 29s-13 29-29 29H103l60 53c11 10 12 29 2 40-11 12-29 13-41 3z"
})));